export default __webpack_public_path__ + "static/media/ic_gift_yellow.ac9a0555.svg";